import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import useWindowWidth from "./_utils/useWindowWidth";

import "./App.css";

import Navbar from "./navbar/Navbar";
import NavbarResponsive from "./navbar/NavbarResponsive";
import Footer from "./footer/Footer";
import LandingPage from "./landing-page/LandingPage";
import Services from "./services/Services";
import AboutMe from "./about-me/AboutMe";
import RedirectModal from "./_components/redirect/RedirectModal";

function App() {
  const width = useWindowWidth();
  const [navbar, setNavbar] = useState(null);

  useEffect(() => {
    const renderNav = width <= 900 ? <NavbarResponsive /> : <Navbar />;
    setNavbar(renderNav);
  }, [width]);

  console.log(window.location.href)

  if (
    window.location.href.includes('vestahealingpsychotherapy.com') ||
    window.location.href.includes('vestahealingnyc.org')
  ) {
    return <RedirectModal />
  }

  return (
    <div className="App">
      {navbar}
      <Routes>
        <Route index exact element={<LandingPage />} />
        <Route path="/about-me" element={<AboutMe />} />
        <Route path="/services" element={<Services />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
